<template>
  <div class="app-container">
    <div class="header">
      <div class="search" style="width: 60%">
        <el-select
          class="search-select"
          clearable
          v-model="formInline.positionId"
          placeholder="请选择广告位置"
        >
          <el-option
            v-for="item in positionData"
            :key="item.positionId"
            :label="item.name"
            :value="item.positionId"
          >
          </el-option>
        </el-select>
        <el-input
          class="search-input"
          style="width: 200px"
          v-model="formInline.name"
          placeholder="请输入要查询关键字"
        ></el-input>
        <el-button icon="el-icon-search" size="small" @click="onSearch"
          >查询</el-button
        >
        <el-button size="small" @click="onRefresh" icon="el-icon-refresh"
          >刷新</el-button
        >
      </div>
      <div>
        <el-button-group style="marginRight">
          <!-- 导出 -->
          <PermissionsBtn
            :icon="'el-icon-download'"
            :btnType="'primary'"
            :permissionName="'_Export'"
            :downloadUrl="'/productAdmin/Ad/downLoad_ad'"
            :checkList="checkList"
            :form="formInline"
          ></PermissionsBtn>
          <el-button
            style="margin: 0 10px"
            type="primary"
            icon="el-icon-plus"
            @click="onAdd"
            v-if="roleList[path].includes('_Add')"
            >新增</el-button
          >
          <!-- <el-button type="primary" icon="el-icon-edit" @click="onEdit"></el-button> -->
          <!-- <el-button type="danger" icon="el-icon-delete" @click="onRemove">删除</el-button> -->
        </el-button-group>

        <el-dropdown>
          <el-button type="success">
            更多菜单<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="onGoto()"
              >广告位管理</el-dropdown-item
            >
            <el-dropdown-item
              @click.native="onAdChange('open')"
              v-if="roleList[path].includes('_Open')"
              >开启广告</el-dropdown-item
            >
            <el-dropdown-item
              @click.native="onAdChange('close')"
              v-if="roleList[path].includes('_Close')"
              >关闭广告</el-dropdown-item
            >
            <el-dropdown-item
              @click.native="onAdChange('recommend')"
              v-if="roleList[path].includes('_Set_recommend')"
              >设置推荐</el-dropdown-item
            >
            <el-dropdown-item
              @click.native="onAdChange('norecommend')"
              v-if="roleList[path].includes('_Cancel_recommend')"
              >取消推荐</el-dropdown-item
            >
            <el-dropdown-item
              @click.native="onRemove"
              v-if="roleList[path].includes('_Delete')"
              >批量删除</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>

    <el-table
      v-loading="listLoading"
      height="750"
      :data="tableData"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
      @selection-change="handleSelectionChange"
    >
      <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
      <el-table-column align="center" width="50" label="编号">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column type="selection" width="55"> </el-table-column>

      <el-table-column label="位置" width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.positionId | filterPosition }}
        </template>
      </el-table-column>

      <el-table-column label="区域" width="60" align="center">
        <template slot-scope="scope">
          {{ scope.row.areaId | filterArea }}
        </template>
      </el-table-column>

      <el-table-column label="广告图" width="100" align="center">
        <template slot-scope="scope">
          <img :src="scope.row.picture" style="width: 100%" />
        </template>
      </el-table-column>

      <el-table-column label="广告名" width="200" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.adName }}</span>
        </template>
      </el-table-column>
      <el-table-column class-name="status-col" label="是否开启" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.isOpen ? 'success' : 'info'">{{
            scope.row.isOpen ? '是' : '否'
          }}</el-tag>
        </template>
      </el-table-column>

      <el-table-column class-name="status-col" label="是否推荐" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.isRecommend ? 'success' : 'info'">{{
            scope.row.isRecommend ? '是' : '否'
          }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="mini"
            @click="onEditItem(scope)"
            v-if="roleList[path].includes('_Update')"
            >编辑</el-button
          >
          <el-button
            type="text"
            size="mini"
            @click="onDeleteItem(scope)"
            v-if="roleList[path].includes('_Delete')"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <Pagination ref="Pagination" />

    <!-- 修改表单对话框 -->
    <editBanner
      ref="editBanner"
      :positionData="positionData"
      :areaData="areaData"
    />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'; // 分页
const editBanner = () => import('./editBanner'); // 表单
// 导入用户接口
import { getCityList } from '@/api/areaApi.js';
import {
  bannerList,
  bannerRemove,
  positionList,
  bannerChange,
  houseNewsApi,
} from '@/api/bannerApi.js';
import { mapGetters } from 'vuex';
var that;
export default {
  components: {
    Pagination,
    editBanner,
  },
  inject: ['reload'],

  data() {
    return {
      listLoading: false,
      tableData: [],
      positionData: [],
      areaData: [],
      pageIndex: 1,
      pageSize: 10,
      formInline: {
        name: '',
        positionId: '',
      },
      path: '',
      multipleSelection: [],
      checkList: [],
    };
  },
  computed: {
    ...mapGetters(['checkNodeData', 'paginObj', 'roleList']),
  },
  beforeCreate() {
    that = this;
  },
  created() {
    const arr = this.$route.path.split('/');
    this.path = arr[arr.length - 1];
  },
  mounted() {
    this.getArea();
    this.getPositionList();
    this.getList();
    this.getBannerLink();
  },
  filters: {
    filterPosition: function (id) {
      let name = '';
      that.positionData.forEach((item) => {
        if (item.positionId === id) {
          name = item.name;
        }
      });
      return name;
    },
    filterArea: function (id) {
      let name = '';
      that.areaData.forEach((item) => {
        if (item.areaId === id) {
          name = item.areaName;
        }
      });
      return name;
    },
  },
  watch: {
    checkNodeData: 'getList',
    paginObj: 'getList',
  },
  methods: {
    async getBannerLink() {
      const areaId = localStorage.getItem('areaId')
        ? JSON.parse(localStorage.getItem('areaId')).areaId
        : '';
      const res = await houseNewsApi(areaId);
      if (res.code !== 200) return;
      // console.log('获取下拉列表：', res.data);
      // this.link = res.data;
      if (this.$refs.editBanner && this.$refs.editBanner.link) {
        this.$refs.editBanner.link = res.data;
      }
    },
    // 获取数据的方法
    getPositionList() {
      positionList().then((res) => {
        this.positionData = res.data.adPositions;
      });
    },
    // 获取数据的方法
    getArea() {
      getCityList().then((res) => {
        this.areaData = res.data.dataList;
      });
    },
    // 获取数据的方法
    getList() {
      const areaId = localStorage.getItem('areaId')
        ? JSON.parse(localStorage.getItem('areaId')).areaId
        : '';
      try {
        this.listLoading = true;
        bannerList({
          areaId:
            this.checkNodeData.data === undefined
              ? areaId
              : this.checkNodeData.data.areaId,
          pageSize: this.paginObj.pageSize,
          pageIndex: this.paginObj.pageIndex,
          name: this.formInline.name,
          positionId: this.formInline.positionId,
        }).then((res) => {
          localStorage.setItem(
            'areaId',
            JSON.stringify({
              areaId:
                this.checkNodeData.data === undefined
                  ? areaId
                  : this.checkNodeData.data.areaId,
            })
          );
          if (res.data == null) {
            this.tableData = [];
            this.listLoading = false;
            return;
          }
          this.tableData = res.data.dataList;
          this.pageIndex = res.data.pageIndex;
          this.pageSize = res.data.pageSize;
          this.listLoading = false;
          this.$refs.Pagination.pageSize = res.data.pageSize;
          this.$refs.Pagination.pageIndex = res.data.pageIndex;
          this.$refs.Pagination.totalCount = res.data.totalCount;
        });
      } catch (e) {
        window.console.log(e);
      }
    },
    // 选中
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.checkList = val.map((item) => {
        return item.adId;
      });
    },
    onGoto: function () {
      this.$router.push({ path: '/home/ubanner/position' });
    },
    // 搜索
    onSearch() {
      this.getList();
    },
    // 刷新当前页面
    onRefresh() {
      this.reload();
    },

    // 增加
    onAdd() {
      this.$refs.editBanner.adId = '';
      this.$refs.editBanner.dialogTitle = '新增广告';
      // this.$refs.editBanner.adTypes = [
      //   {
      //     lable: '非浮窗广告',
      //     id: -1,
      //   },
      //   {
      //     lable: '小广告',
      //     id: 0,
      //   },
      //   {
      //     lable: '长广告',
      //     id: 1,
      //   },
      // ];
      this.$refs.editBanner.dialogFormVisible = true;
    },
    // 单条编辑
    onEditItem(scope) {
      this.currentRow = scope.row;
      this.$refs.editBanner.adId = scope.row.adId;
      this.$refs.editBanner.dialogTitle = '编辑广告';
      this.$refs.editBanner.dialogFormVisible = true;
      // console.log('编辑：', scope.row);
      // this.$refs.editBanner.adTypes = [
      //   {
      //     lable: '非浮窗广告',
      //     id: -1,
      //   },
      //   {
      //     lable: '小广告',
      //     id: 0,
      //   },
      //   {
      //     lable: '长广告',
      //     id: 1,
      //   },
      // ];
      this.$refs.editBanner.editForm = JSON.parse(JSON.stringify(scope.row));

      // console.log('editForm', this.$refs.editBanner.editForm);
      // this.$refs.editBanner.editForm.adType = scope.row.adType;
    },
    // 单条删除
    onDeleteItem(scope) {
      const item = scope.row;
      let checkAdIds = [];
      checkAdIds.push(item.adId);
      this.funcRemove(checkAdIds);
    },

    // 勾选编辑
    onEdit() {
      if (this.multipleSelection.length === 0)
        return this.$message.error('请选择要编辑的数据');
      if (this.multipleSelection.length > 1)
        return this.$message.error('请选择要编辑的单条数据');
      this.$refs.editBanner.dialogFormVisible = true;
      this.$refs.editBanner.editForm = JSON.parse(
        JSON.stringify(this.multipleSelection)
      );
    },
    // 勾选改变
    onAdChange(ty) {
      let checkAdIds = [];
      this.multipleSelection.forEach((item) => {
        checkAdIds.push(item.adId);
      });
      try {
        if (checkAdIds.length === 0)
          return this.$message.error('请选择要设置的数据');
        this.$confirm('是否确认设置数据', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'error',
        })
          .then(async () => {
            await bannerChange(ty, checkAdIds).then((res) => {
              if (res.code === 200) {
                this.onRefresh();
                this.$message.success('设置成功!');
              } else {
                this.$message.info('设置失败：' + res.message);
              }
            });
          })
          .catch(() => {
            this.$message.info('设置出错');
          });
      } catch (e) {
        this.$message.info('设置出错:' + e.message);
        window.console.log(e);
      }
    },
    // 勾选删除
    onRemove() {
      let checkAdIds = [];
      this.multipleSelection.forEach((item) => {
        checkAdIds.push(item.adId);
      });
      this.funcRemove(checkAdIds);
    },
    funcRemove: function (checkAdIds) {
      try {
        if (checkAdIds.length === 0)
          return this.$message.error('请选择要删除的数据');
        this.$confirm('是否狠心删除该数据', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'error',
        })
          .then(async () => {
            await bannerRemove({ idList: checkAdIds }).then((res) => {
              if (res.code === 200) {
                this.onRefresh();
                this.$message.success('删除成功!');
              } else {
                this.$message.info('删除失败：' + res.message);
              }
            });
          })
          .catch(() => {
            this.$message.info('删除出错');
          });
      } catch (e) {
        this.$message.info('删除出错:' + e.message);
        window.console.log(e);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.app-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  .search {
    display: flex;
    width: 800px;

    .search-input {
      margin: 0 10px;
      width: 300px;
    }

    .search-picker {
      width: 250px;
    }

    .search-select {
      margin-right: 10px;
    }
  }

  button {
    height: 40px;
  }
}
.btn {
  display: flex;
  align-items: center;
}
/deep/ .el-checkbox__input {
  margin-left: 10px;
}
</style>
